import { QueryCache, QueryClient } from "@tanstack/react-query";
import { notify } from "cy-fe";
import { QueryError } from "cy-remittance/send-money";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
  queryCache: new QueryCache({
    onError: (err, query) => {
      const queryError = query.meta?.error as QueryError | undefined;
      if (queryError) {
        if (queryError.type === "generic") {
          notify("Error", "An unknown Error ocurred", { error: err });
        }
      }
    },
  }),
});
